import { render, staticRenderFns } from "./AtestoDocumentacao.vue?vue&type=template&id=eace9c0e"
import script from "./AtestoDocumentacao.vue?vue&type=script&lang=js"
export * from "./AtestoDocumentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports